import { useMutation } from '@ts-gql/apollo';
import { gql } from '@ts-gql/tag';
import React from 'react';

const mutation = gql`
  mutation UpdateTaskStatus($input: UpdateTaskStatusInput!) {
    updateTaskStatus(input: $input) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
    }
  }
` as import('../../__generated__/ts-gql/UpdateTaskStatus').type;

export const useUpdateTaskStatus = () => {
  const tuple = useMutation(mutation);

  const [_mutate, result] = tuple;

  const mutate = React.useCallback<typeof _mutate>(
    (options) =>
      _mutate({
        context: { service: 'core' },
        // refetchQueries: options.variables && [
        //   {
        //     query: GET_TASK_QUERY,
        //     variables: { cloudId: options.variables.input.cloudId },
        //   },
        // ],
        refetchQueries: ['GetTask', 'SearchTasks', 'SearchTasksWithJob'],
        awaitRefetchQueries: true,
        ...options,
      }),
    [_mutate]
  );

  return React.useMemo<typeof tuple>(() => [mutate, result], [mutate, result]);
};
